import { createContext, useContext, type ReactNode } from "react";

/**
 * The order summary as the phone bar's expandable sheet shows it: the same
 * per-supplier roll-up as the summary card at the end of the page, so the
 * buyer can check subtotals, shipping and GST from the bar without scrolling
 * past the form.
 *
 * A context for the same reason as CheckoutActionSlot: CheckoutPage owns the
 * carts and totals the summary reads, while the step owns the bar, and the
 * two are siblings. The page hands the bar an element to show rather than
 * the bar learning how to build one.
 *
 * `null` when there is nothing to show (and in the bar's own tests), in which
 * case the bar has no toggle and behaves as a plain total beside the action.
 */
export const CheckoutSummarySheetContext = createContext<ReactNode>(null);

export function useCheckoutSummarySheet(): ReactNode {
  return useContext(CheckoutSummarySheetContext);
}
